import { useState } from "react";
import FileUploadField from "../../components/FileUploadField";
import FormSuccess from "../../components/FormSuccess";
import { useSubmission } from "../../utils/useSubmission";

const BLANK = {
  companyOrName: "", contactEmail: "", contactPhone: "", areaOfInterest: "", message: "",
};

export default function GeneralInterestPage() {
  const [f, setF] = useState(BLANK);
  const [files, setFiles] = useState([]);
  const { submitting, error, setError, success, submit } = useSubmission({
    collectionName: "generalInterest", storageFolder: "general-interest",
  });

  const set = (k, v) => setF(prev => ({ ...prev, [k]: v }));

  const onSubmit = e => {
    e.preventDefault();
    if (!f.companyOrName || !f.contactEmail || !f.areaOfInterest) {
      setError("Please fill in all required fields.");
      return;
    }
    submit(f, files);
  };

  if (success) {
    return (
      <section className="sec"><div className="container">
        <FormSuccess title="Interest Registered"
          message="Thank you — we've recorded your interest and will be in touch about relevant Papua New Guinea opportunities." />
      </div></section>
    );
  }

  return (
    <>
      <div className="pg-hdr">
        <h1>General Business Interest</h1>
        <p>For Korean companies interested in other Papua New Guinea projects and opportunities beyond Papua LNG.</p>
      </div>
      <section className="sec">
        <div className="container">
          <form className="form-card fade-up" onSubmit={onSubmit}>
            {error && <div className="form-err-banner">{error}</div>}

            <div className="field">
              <label>Company / Your Name <span className="req">*</span></label>
              <input value={f.companyOrName} onChange={e => set("companyOrName", e.target.value)} required/>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Contact Email <span className="req">*</span></label>
                <input type="email" value={f.contactEmail} onChange={e => set("contactEmail", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Contact Phone</label>
                <input value={f.contactPhone} onChange={e => set("contactPhone", e.target.value)}/>
              </div>
            </div>

            <div className="field">
              <label>Area of Interest <span className="req">*</span></label>
              <input value={f.areaOfInterest} onChange={e => set("areaOfInterest", e.target.value)}
                placeholder="e.g. mining, infrastructure, agriculture, other PNG energy projects" required/>
            </div>

            <div className="field">
              <label>Message</label>
              <textarea value={f.message} onChange={e => set("message", e.target.value)}
                placeholder="Tell us more about what you're looking for"/>
            </div>

            <FileUploadField label="Supporting Documents (optional)"
              hint="Company profile or other supporting material, PDF or Word, max 10MB each"
              files={files} setFiles={setFiles} onError={setError}/>

            <button className="btn-g" style={{ width: "100%", marginTop: ".5rem" }} disabled={submitting}>
              {submitting ? "Submitting…" : "Register Interest →"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
